import { useMemo } from "react";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryPayoutSettings } from "../../../query/payments/queries";
import { selectorInstantPayoutDefaultFee } from "../../../shared/selectors/selectorInstantPayoutDefaultFee";

export function useInstantPayoutFee() {
  const userId = useUserId();
  const queryPayoutSettings = useQueryPayoutSettings(userId);
  return useMemo(
    () => selectorInstantPayoutDefaultFee(queryPayoutSettings.data),
    [queryPayoutSettings.data]
  );
}
